export default "__VITE_ASSET__erp7HPhC__"